var _rect, _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconWorkspaceDBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 4,
    fill: "black"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 10,
    fill: "#E9EBED"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8828 21V9.79688H14.1172C18.2474 9.79688 20.3125 11.6172 20.3125 15.2578C20.3125 16.987 19.7396 18.3776 18.5938 19.4297C17.4479 20.4766 15.9115 21 13.9844 21H10.8828ZM12.7344 11.375V19.4297H14.2188C15.526 19.4297 16.5417 19.0703 17.2656 18.3516C17.9948 17.6328 18.3594 16.6172 18.3594 15.3047C18.3594 12.6849 17.0026 11.375 14.2891 11.375H12.7344Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWorkspaceDBlack);
export default __webpack_public_path__ + "static/media/Icon_WorkspaceD_Black.e6ca03fa70ab94e24d7f2d5e97b4afff.svg";
export { ForwardRef as ReactComponent };